import Link from 'next/link';
import { CardProps } from './types';
import DirectusImage from '../image/DirectusImage';
import TitleH2 from '../common/TitleH2';
import DefaultTeamLogo from '../../../../public/svg/ball_white.svg';
import Image from 'next/image';
import getDirectusImageUrl from '@/lib/utils/image';
import SocialLinkGradient from '../link/SocialLinkGradient';

export default function CardSocial({
  background,
  backgroundEllipse = 'md:bg-card-small-push-no-image-right-ellipse',
  button,
  callToActionUrl: { url, external, slug },
  image,
  imageAlt,
  imageSizes,
  stylesImage,
  title,
  intro,
  imageBlur,
  socials_items,
}: CardProps) {
  const sizes = imageSizes || '100vw';
  let transparentBg = false;
  let border = true;

  if (button) {
    transparentBg = button.buttonStyle === 'secondary';
    border = button.buttonStyle === 'primary';
  }

  const gradientImage = image
    ? 'from-astro-gradient-start to-astro-gradient-end bg-gradient-to-t'
    : '';

  let cardBackground = image ? '' : 'bg-gray-100';
  if (!image && background === 'blue') {
    cardBackground = 'bg-indigo-950';
  }
  if (!image && background === 'gradient') {
    cardBackground = 'bg-gradient-to-r from-blue-900 via-blue-900 to-red-600';
  }

  let textColorType = (image ? 'default' : 'black') as 'default' | 'black';
  if (background === 'blue') {
    textColorType = 'default';
  }
  if (background === 'gradient') {
    textColorType = 'default';
  }
  const cardTextAlignment = image ? 'justify-end' : 'justify-center items-center';
  const ellipseBackground = image
    ? ''
    : `bg-card-small-push-no-image-ellipse-mobile md:bg-card-small-push-no-image-ellipse bg-card-small-push-no-image-right-ellipse-mobile ${backgroundEllipse}`;

  return (
    <div
      className={`${cardBackground} ${ellipseBackground} md:py-auto card relative flex w-full flex-col rounded-md ${cardTextAlignment} ${stylesImage}`}
    >
      {!image && <div className="md:bg-card-small-push-no-image" />}
      {image && (
        <div className={`${gradientImage} absolute bottom-0 z-10 h-full w-full rounded-md`} />
      )}
      {image && (
        <DirectusImage
          src={image || ''}
          alt={imageAlt || ''}
          blur={imageBlur}
          dimension={{ sizes }}
          styles="rounded-md bg-black opacity-90"
        />
      )}
      <div
        className={`relative z-10 gap-3 py-[20px] md:gap-2 md:px-10 md:py-[40px] ${image ? 'flex h-full min-h-60 flex-col items-start justify-end' : 'flex h-full flex-col items-center justify-center gap-8'}`}
      >
        {intro && (
          <div
            className={`mx-5 flex h-[15px] items-center justify-center gap-2 text-[11px] text-xs uppercase leading-3 md:mx-7 ${image ? 'text-white' : 'text-gray-400'}`}
          >
            {image && <Image src={DefaultTeamLogo} width={13} height={13} alt={intro} />}
            {intro}
          </div>
        )}
        {!image && (
          <TitleH2
            color={textColorType}
            customFont={true}
            heading={false}
            size="default"
            styles="w-[85%] md:w-[95%] mx-5 md:mx-7 text-center"
            titleBold={false}
            titleUpperCase={true}
            titleTracking="leading-[33px] md:leading-relaxed lg:tracking-[1.35px]"
          >
            {title}
          </TitleH2>
        )}
        {image && (
          <TitleH2
            color={textColorType}
            customFont={false}
            heading={false}
            size="small"
            styles="w-[85%] md:w-[95%] mx-5 md:mx-7"
            titleBold={false}
            titleUpperCase={false}
            titleTracking="leading-loose leading-relaxed lg:tracking-[1.35px]"
          >
            {title}
          </TitleH2>
        )}
        {socials_items && socials_items.length > 0 && (
          <div className="flex gap-2">
            {socials_items.map((social, index) => {
              return (
                social?.image &&
                social?.url && (
                  <SocialLinkGradient
                    key={index}
                    item={{ ...social, external: true }}
                    url={social.url}
                    style="light"
                    size="large"
                  >
                    <Image
                      key={index}
                      alt={social.title || ''}
                      src={getDirectusImageUrl(social.image, true) || ''}
                      width={25}
                      height={25}
                    />
                  </SocialLinkGradient>
                )
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
